module.exports = __webpack_public_path__ + "1aafd3714e62eb2f2d6c76aba1e788cb.png";